import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';

export const ActiveDirectoryDetailsHeaderStyled = styled.div`
    width: 100%;
    padding: 16px;
    background-color: ${owcTheme['one-color-background-base']};
    border-bottom: 1px solid ${owcTheme['one-color-background-contrast']};
`;
